import React from "react";
import { useParams } from "react-router-dom";
import AssetListCrud from "./asset-list-crud";

export default function ScreenshotsForm() {
  const { casestudyId } = useParams();
  return (
    <div className="flex-1 p-4">
      <AssetListCrud
        title="Screenshots"
        storageKey={casestudyId}
        endPoint="case_studies_screenshots"
        entityId={casestudyId}
        relation={{ entityField: "case_study", assetField: "screenshot" }}
        required={true}
      />
    </div>
  );
}
